


export class ProfileForumTopicView {
    constructor() {

        this.template = document.querySelector('#forum-topic-template');
        this.container = document.querySelector('section.sc_forum div.sc_body div.ul');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        const data = state.data;
        const section = document.querySelector('section.sc_forum');
        if (section) {

            const title = section.querySelector('div.sc_title strong');
            if (title) { title.textContent = data.title;}

            const count = section.querySelector('div.sc_title em');
            if (count && data.totalCount) { count.textContent = data.totalCount;}

            const url = section.querySelector('a.sc_header');
            if (url) {

                url.href = data.url;

                if (data.totalCount > 6) {
                    const more = url.querySelector('div.sc_more');
                    if (more) { more.style.display = '';}
                }
            }
        }

        if (!data.models.length) {

            section.classList.add('empty');
            const scrollSlider = section.querySelector('div.scroll_slider');
            if (scrollSlider) { scrollSlider.remove();}
            //section.querySelectorAll('div.ul .li').forEach(el => el.remove());

            const emptyBody = section.querySelector('.sc_body_empty');
            if (emptyBody && data.addUrl != false) {

                const addLink = document.createElement('a');
                addLink.classList.add('add_button');
                addLink.textContent = data.addUrl.tip;
                addLink.href = data.addUrl.url;
                emptyBody.appendChild(addLink);
            }

            emptyBody.style.display = '';
            
            return;
        }

        const slides = this.container.querySelectorAll('.li.slide');
        let index = 0;

        slides.forEach(slide => {

            const dummies = slide.querySelectorAll('div.item'); 
            dummies.forEach(dummy => {

                if (!data.models[index]) {
                    dummy.closest('.item').remove();
                    return;
                }

                const model = data.models[index];

                const t = this.renderPartial(model);

                dummy.replaceWith(t);

                index += 1;

            });
        });
    }

    renderPartial(data) {

        const t = this.template.content.cloneNode(true);
        const article = t.querySelector('article');
        if (article) {

            article.classList.remove('dummy');
            article.dataset.id = data.content.id;

            const author = article.querySelector('a.user');
            if (author) {

                author.href = data.author.profile.url;
                const avatar = author.querySelector('img');
                if (avatar) {
                    avatar.src = data.author.avatar.url;
                    avatar.alt = data.author.username;
                }

                const username = author.querySelector('span');
                if (username) {
                    username.textContent = data.author.username;
                }
            }

            const date = article.querySelector('.date');
            if (date) {
                date.textContent = data.created.date + ', ' + data.created.time;
            }

            const title = article.querySelector('div.title a');
            if (title) {

                title.href = data.content.url;
                title.textContent = data.content.title;
            }


            const counters = t.querySelector('.counters');
            if (counters) {
                const like = counters.querySelector('.ci.like span');
                if (data.counters.likes?.tip) {
                    like.parentElement.dataset.tooltip = data.counters.likes.tip;
                }
                if (like && data.counters?.likes) {
                    like.textContent = data.counters.likes.count;
                    if (data.counters.likes?.isActive) {
                        counters.querySelector('.ci.like').classList.add('toggled');
                    }
                }

                const comments = counters.querySelector('.ci.comments span');
                if (comments && data.counters?.comments) {
                    comments.textContent = data.counters.comments.count;
                    if (data.counters.comments?.tip) {
                        comments.parentElement.dataset.tooltip = data.counters.comments.tip;
                    }
                    if (data.counters.comments?.class) {
                        comments.parentElement.parentElement.classList.add(...data.counters.comments.class);
                    }
                    const commentLink = counters.querySelector('.ci.comments a');
                    if (commentLink) { commentLink.href = data.content.url + '#comments';}
                }

                const views = counters.querySelector('.ci.views span');
                if (views && data.counters?.views) {
                    views.textContent = data.counters.views.count;
                    if (data.counters.views?.tip) {
                        views.parentElement.dataset.tooltip = data.counters.views.tip;
                    }
                }
            }
        }

        return t;
    }
}